import api, { toUserError } from './api'

function toPublicUser(user) {
  if (!user) return null
  const copy = { ...user }
  delete copy.passwordHash
  delete copy.password
  return {
    ...copy,
    permissions: {
      canTransact: Boolean(copy.permissions?.canTransact),
    },
  }
}

export async function fetchUsers() {
  try {
    const { data } = await api.get('/users')
    return (data.data?.users || []).map(toPublicUser)
  } catch (error) {
    throw toUserError(error)
  }
}

export async function createUser(payload) {
  try {
    const { data } = await api.post('/users', payload)
    return toPublicUser(data.data?.user)
  } catch (error) {
    throw toUserError(error)
  }
}

export async function updateUser(id, payload) {
  try {
    const { data } = await api.put(`/users/${id}`, payload)
    return toPublicUser(data.data?.user)
  } catch (error) {
    throw toUserError(error)
  }
}

export async function updateUserPassword(id, password) {
  try {
    const { data } = await api.put(`/users/${id}/password`, { password })
    return toPublicUser(data.data?.user)
  } catch (error) {
    throw toUserError(error)
  }
}
